import { ALERT_ICON_PATH, BACK_ICON_PATH, T_LOGO_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  onClickBackBtn: () => void;
}

const SendCheckViewHeader = ({ onClickBackBtn }: IProps) => {
  return (
    <header className="ili-header sticky-header">
      <a className="back-area">
        <img src={BACK_ICON_PATH} alt="back-icon" onClick={onClickBackBtn} />
      </a>
      <a className="inner" href="#">
        <div className="img">
          <img src={T_LOGO_ICON_PATH} alt="Logo" />
        </div>
        <h2>보내기 확인</h2>
      </a>
      <div className="icon-area">
        <img src={ALERT_ICON_PATH} alt="alert-icon" style={{ opacity: 0 }} />
      </div>
    </header>
  );
};

export default SendCheckViewHeader;
